<template>
    <div class="flex">
        <UserAvatar
            :firstName="user.firstName || ''"
            :lastName="user.lastName || ''"
            :imageUrl="imageUrl"
            :size="48" class="mr-2"
            v-if="user"
        />

        <div>
            <div class="ds-text-xl font-bold text-gray-800" style="overflow-wrap: break-word; word-break: break-word;">{{videoName}}</div>
            <div v-if="user">By {{user.firstName}} {{user.lastName}}</div>
        </div>
    </div>
</template>

<script>
    import UserAvatar from '@/components/UserAvatar'

    export default {
        components: { UserAvatar },

        props: {
            video: { type: Object, required: true },
        },

        computed: {
            videoName() {
                return this.video.name
            },

            user() {
                return this.video.owner
            },

            imageUrl() {
                const image = this.user.images.find(image => image.isProfile)
                return image ? image.url : null
            },
        }
    }
</script>